import { IsNotEmpty, IsIn, IsOptional, IsBoolean } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IScentScore } from "./scent-score.interface";

export class ScentScoreDto implements IScentScore {
  //
  @IsNotEmpty()
  @IsIn([
    ...Object.values(Constants.score_result_type),
    ...Object.values(Constants.cwags_scent_result)
  ])
  result_type: string;

  @IsOptional()
  score?: number;

  @IsOptional()
  @IsBoolean()
  scent1?: boolean;

  @IsOptional()
  @IsBoolean()
  scent2?: boolean;

  @IsOptional()
  @IsBoolean()
  scent3?: boolean;

  @IsOptional()
  @IsBoolean()
  scent4?: boolean;

  @IsOptional()
  fault1?: string;

  @IsOptional()
  fault2?: string;

  @IsOptional()
  search_time?: string;
}
